import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || "20"}
    height={props.height || "20"}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.6406 4.375H5.35938C5.05734 4.375 4.8125 4.13016 4.8125 3.82812V2.40625C4.8125 1.07729 5.88979 0 7.21875 0H20.7812C22.1102 0 23.1875 1.07729 23.1875 2.40625V3.82812C23.1875 4.13016 22.9427 4.375 22.6406 4.375Z"
      fill="#556987"
    />
    <path
      d="M25.0469 6.125H2.95312C1.32475 6.125 0 7.44975 0 9.07812V19.3594C0 20.9878 1.32475 22.3125 2.95312 22.3125H4.8125V17.9375C4.8125 15.7664 6.57885 14 8.75 14H19.25C21.4211 14 23.1875 15.7664 23.1875 17.9375V22.3125H25.0469C26.6752 22.3125 28 20.9878 28 19.3594V9.07812C28 7.44975 26.6752 6.125 25.0469 6.125ZM5.25109 12.6875C4.52621 12.6875 3.93832 12.0999 3.93832 11.375C3.93832 10.6501 4.52566 10.0625 5.25055 10.0625H5.25109C5.97598 10.0625 6.56359 10.6501 6.56359 11.375C6.56359 12.0999 5.97598 12.6875 5.25109 12.6875Z"
      fill="#556987"
    />
    <path
      d="M19.25 16.625H8.75C8.02512 16.625 7.4375 17.2126 7.4375 17.9375V22.3125V24.0625C7.4375 24.7874 8.02512 25.375 8.75 25.375H19.25C19.9749 25.375 20.5625 24.7874 20.5625 24.0625V22.3125V17.9375C20.5625 17.2126 19.9749 16.625 19.25 16.625Z"
      fill="#556987"
    />
  </svg>
);

export default SvgComponent;
